import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/api';

import { labelSymbol } from '../helpers/enum-helpers';

@Pipe({
    name: 'enumSelect',
    standalone: false
})
export class EnumSelectPipe implements PipeTransform {
    public transform(enumObj: any, nullOptionText: string = null): SelectItem[] {
        return [
            ...(nullOptionText ? [{ value: null, label: nullOptionText }] : []),
            ...[...(<Map<any, string>> enumObj[labelSymbol]).entries()]
                .map(keyval => ({ value: keyval[0], label: keyval[1] }))
        ];
    }
}
